
import { TemplateStyle } from './types';

export const companyName = "شركة السياحة الرائدة";

export const initialSections = [
    { id: 'client', name: 'معلومات العميل' },
    { id: 'hotels', name: 'الفنادق' },
    { id: 'flights', name: 'الطيران' },
    { id: 'tours', name: 'الجولات' },
    { id: 'price', name: 'السعر' },
    { id: 'notes', name: 'ملاحظات' },
    { id: 'terms', name: 'الشروط والأحكام' },
    { id: 'itinerary', name: 'جدول الرحلة' },
    { id: 'contact', name: 'معلومات التواصل' },
    { id: 'offers', name: 'عروض خاصة' },
];

export const defaultSettings: { [key: string]: TemplateStyle } = {
  template1: {
    colors: { primary: '#667eea', text: '#ffffff', background: '#f8f9fa' },
    columns: [{ id: 'main', sections: [...initialSections] }],
    layoutGridCols: 1,
    media: {},
  },
  template2: {
    colors: { primary: '#007bff', text: '#333333', background: '#f9f9f9' },
    columns: [{ id: 'main', sections: [...initialSections] }],
    layoutGridCols: 1,
    media: {},
  },
  template3: {
    colors: { primary: '#c4a75c', text: '#f0f0f0', background: '#383838' },
    columns: [{ id: 'main', sections: [...initialSections] }],
    layoutGridCols: 1,
    media: {},
  },
  template4: {
    colors: { primary: '#0891b2', text: '#f8fafc', background: '#1e293b' },
    columns: [{ id: 'main', sections: [...initialSections] }],
    layoutGridCols: 1,
    media: {},
  },
  template5: {
    colors: { primary: '#881337', text: '#1f2937', background: '#fefce8' },
    columns: [{ id: 'main', sections: [...initialSections] }],
    layoutGridCols: 1,
    media: {},
  },
  template6: {
    colors: { primary: '#7c3aed', text: '#111827', background: '#f3f4f6' },
    columns: [{ id: 'main', sections: [...initialSections] }],
    layoutGridCols: 1,
    media: {},
  },
};

export const getDefaultSettingsForTemplate = (templateId: string): TemplateStyle => {
  return defaultSettings[templateId] || defaultSettings.template1;
};
